import { GolfCourse } from '../types';

export const courses: GolfCourse[] = [
  {
    id: 'blackhorse-north',
    name: 'BlackHorse Golf Club (North)',
    location: 'Cypress, TX',
    parValues: [4, 3, 5, 4, 4, 3, 4, 5, 4, 4, 5, 4, 4, 3, 4, 3, 4, 5],
    holeHandicaps: [9, 13, 15, 1, 3, 11, 7, 17, 5, 4, 6, 8, 16, 18, 2, 12, 10, 14],
    tees: [
      {
        name: 'Black',
        rating: 75.7,
        slope: 138,
        yardage: 7301
      },
      {
        name: 'Blue',
        rating: 72.7,
        slope: 132,
        yardage: 6615
      },
      {
        name: 'White',
        rating: 71.1,
        slope: 123,
        yardage: 6199
      }
    ]
  },
  {
    id: 'blackhorse-south',
    name: 'BlackHorse Golf Club (South)',
    location: 'Cypress, TX',
    parValues: [4, 4, 4, 3, 5, 3, 4, 4, 5, 4, 4, 4, 3, 4, 5, 4, 3, 5],
    holeHandicaps: [9, 5, 3, 11, 7, 17, 15, 1, 13, 18, 14, 6, 10, 4, 2, 16, 8, 12],
    tees: [
      {
        name: 'Black',
        rating: 75.7,
        slope: 138,
        yardage: 7191
      },
      {
        name: 'Blue',
        rating: 72.1,
        slope: 132,
        yardage: 6434
      },
      {
        name: 'White',
        rating: 70.3,
        slope: 127,
        yardage: 6084
      }
    ]
  },
  {
    id: 'cypress-lakes',
    name: 'Cypress Lakes Golf Club',
    location: 'Cypress, TX',
    parValues: [4, 5, 4, 3, 4, 4, 3, 5, 4, 5, 3, 4, 4, 5, 4, 4, 3, 4],
    holeHandicaps: [17, 5, 1, 9, 3, 15, 13, 7, 11, 6, 16, 12, 14, 8, 4, 10, 18, 2],
    tees: [
      {
        name: 'Blue',
        rating: 73.9,
        slope: 139,
        yardage: 7024
      },
      {
        name: 'White',
        rating: 71.8,
        slope: 131,
        yardage: 6566
      },
      {
        name: 'Gold',
        rating: 70.2,
        slope: 123,
        yardage: 6136
      }
    ]
  },
  {
    id: 'eagle-pointe',
    name: 'Eagle Pointe Golf Club',
    location: 'Mont Belvieu, TX',
    parValues: [4, 4, 5, 3, 4, 4, 5, 3, 4, 4, 4, 3, 5, 4, 4, 3, 4, 4],
    holeHandicaps: [11, 7, 1, 15, 5, 13, 3, 17, 9, 12, 6, 16, 2, 8, 4, 18, 10, 14],
    tees: [
      {
        name: 'Black',
        rating: 73.9,
        slope: 134,
        yardage: 7003
      },
      {
        name: 'Blue',
        rating: 72.8,
        slope: 132,
        yardage: 6703
      },
      {
        name: 'White',
        rating: 71.2,
        slope: 128,
        yardage: 6303
      }
    ]
  },
  {
    id: 'falcon-point',
    name: 'Club at Falcon Point',
    location: 'Katy, TX',
    parValues: [4, 4, 5, 3, 4, 5, 4, 3, 4, 4, 4, 3, 5, 4, 4, 3, 4, 5],
    holeHandicaps: [11, 5, 1, 17, 9, 3, 15, 13, 7, 10, 6, 18, 2, 8, 12, 16, 4, 14],
    tees: [
      {
        name: 'Black',
        rating: 74.6,
        slope: 138,
        yardage: 7094
      },
      {
        name: 'Blue',
        rating: 73.4,
        slope: 136,
        yardage: 6794
      },
      {
        name: 'White',
        rating: 71.6,
        slope: 132,
        yardage: 6394
      }
    ]
  },
  {
    id: 'golf-club-of-houston',
    name: 'Golf Club of Houston (Tournament)',
    location: 'Humble, TX',
    parValues: [4, 4, 5, 3, 4, 4, 5, 3, 4, 4, 4, 3, 5, 4, 3, 4, 4, 4],
    holeHandicaps: [7, 3, 1, 17, 11, 9, 5, 15, 13, 8, 4, 16, 2, 10, 18, 12, 6, 14],
    tees: [
      {
        name: 'Tournament',
        rating: 76.8,
        slope: 144,
        yardage: 7450
      },
      {
        name: 'Championship',
        rating: 74.9,
        slope: 140,
        yardage: 7100
      },
      {
        name: 'Member',
        rating: 72.8,
        slope: 136,
        yardage: 6750
      }
    ]
  },
  {
    id: 'greatwood',
    name: 'Greatwood Golf Club',
    location: 'Sugar Land, TX',
    parValues: [4, 4, 4, 3, 4, 5, 3, 4, 5, 4, 4, 3, 4, 5, 3, 4, 4, 5],
    holeHandicaps: [15, 17, 5, 3, 1, 13, 7, 11, 9, 2, 10, 4, 12, 14, 18, 8, 16, 6],
    tees: [
      {
        name: 'Black',
        rating: 73.9,
        slope: 135,
        yardage: 6830
      },
      {
        name: 'Blue',
        rating: 72.1,
        slope: 132,
        yardage: 6324
      },
      {
        name: 'White',
        rating: 70.8,
        slope: 128,
        yardage: 6332
      }
    ]
  },
  {
    id: 'gus-wortham',
    name: 'Gus Wortham Golf Course',
    location: 'Houston, TX',
    parValues: [4, 4, 5, 3, 4, 4, 5, 3, 4, 4, 4, 3, 4, 5, 4, 3, 4, 5],
    holeHandicaps: [11, 5, 1, 15, 7, 13, 3, 17, 9, 10, 4, 16, 2, 8, 12, 18, 6, 14],
    tees: [
      {
        name: 'Black',
        rating: 73.2,
        slope: 134,
        yardage: 6928
      },
      {
        name: 'Blue',
        rating: 71.8,
        slope: 131,
        yardage: 6628
      },
      {
        name: 'White',
        rating: 70.2,
        slope: 128,
        yardage: 6228
      }
    ]
  },
  {
    id: 'houston-national',
    name: 'Houston National Golf Club',
    location: 'Houston, TX',
    parValues: [4, 4, 5, 3, 4, 4, 5, 3, 4, 4, 4, 3, 5, 4, 4, 3, 4, 5],
    holeHandicaps: [11, 5, 1, 15, 7, 13, 3, 17, 9, 10, 4, 16, 2, 8, 12, 18, 6, 14],
    tees: [
      {
        name: 'Black',
        rating: 74.3,
        slope: 137,
        yardage: 7115
      },
      {
        name: 'Blue',
        rating: 72.8,
        slope: 134,
        yardage: 6815
      },
      {
        name: 'White',
        rating: 71.1,
        slope: 130,
        yardage: 6415
      }
    ]
  },
  {
    id: 'longwood',
    name: 'Longwood Golf Club',
    location: 'Cypress, TX',
    parValues: [5, 4, 4, 4, 4, 3, 5, 3, 5, 3, 4, 4, 4, 3, 5, 4, 4, 4],
    holeHandicaps: [7, 9, 11, 15, 1, 13, 3, 17, 5, 8, 10, 12, 16, 2, 14, 4, 18, 6],
    tees: [
      {
        name: 'Tournament',
        rating: 74.3,
        slope: 137,
        yardage: 7093
      },
      {
        name: 'Back',
        rating: 72.8,
        slope: 134,
        yardage: 6547
      },
      {
        name: 'Middle',
        rating: 71.1,
        slope: 130,
        yardage: 5981
      }
    ]
  },
  {
    id: 'pearland-gc',
    name: 'Pearland Golf Club',
    location: 'Pearland, TX',
    parValues: [4, 4, 5, 3, 4, 4, 5, 3, 4, 4, 4, 3, 5, 4, 4, 3, 4, 5],
    holeHandicaps: [11, 5, 1, 15, 7, 13, 3, 17, 9, 10, 4, 16, 2, 8, 12, 18, 6, 14],
    tees: [
      {
        name: 'Black',
        rating: 73.4,
        slope: 134,
        yardage: 6983
      },
      {
        name: 'Blue',
        rating: 72.1,
        slope: 131,
        yardage: 6683
      },
      {
        name: 'White',
        rating: 70.4,
        slope: 128,
        yardage: 6283
      }
    ]
  },
  {
    id: 'quail-valley-eldorado',
    name: 'Quail Valley (El Dorado)',
    location: 'Missouri City, TX',
    parValues: [4, 4, 5, 3, 4, 4, 3, 4, 5, 4, 3, 4, 4, 5, 4, 3, 4, 5],
    holeHandicaps: [13, 3, 1, 17, 7, 11, 15, 5, 9, 14, 18, 8, 4, 2, 10, 16, 6, 12],
    tees: [
      {
        name: 'Black',
        rating: 74.2,
        slope: 136,
        yardage: 7095
      },
      {
        name: 'Blue',
        rating: 73.1,
        slope: 134,
        yardage: 6795
      },
      {
        name: 'White',
        rating: 71.3,
        slope: 130,
        yardage: 6395
      }
    ]
  },
  {
    id: 'sweetwater-cypress',
    name: 'Sweetwater Country Club (Cypress)',
    location: 'Sugar Land, TX',
    parValues: [4, 4, 5, 3, 4, 4, 5, 3, 4, 4, 4, 3, 5, 4, 4, 3, 4, 5],
    holeHandicaps: [11, 5, 1, 15, 7, 13, 3, 17, 9, 10, 4, 16, 2, 8, 12, 18, 6, 14],
    tees: [
      {
        name: 'Black',
        rating: 73.8,
        slope: 135,
        yardage: 7012
      },
      {
        name: 'Blue',
        rating: 72.4,
        slope: 132,
        yardage: 6712
      },
      {
        name: 'White',
        rating: 70.7,
        slope: 128,
        yardage: 6312
      }
    ]
  },
  {
    id: 'sweetwater-pecan',
    name: 'Sweetwater Country Club (Pecan)',
    location: 'Sugar Land, TX',
    parValues: [4, 4, 5, 3, 4, 4, 5, 3, 4, 4, 4, 3, 5, 4, 4, 3, 4, 5],
    holeHandicaps: [13, 7, 1, 17, 5, 11, 3, 15, 9, 12, 6, 16, 2, 8, 4, 18, 10, 14],
    tees: [
      {
        name: 'Black',
        rating: 74.2,
        slope: 136,
        yardage: 7072
      },
      {
        name: 'Blue',
        rating: 72.8,
        slope: 133,
        yardage: 6772
      },
      {
        name: 'White',
        rating: 71.1,
        slope: 129,
        yardage: 6372
      }
    ]
  },
  {
    id: 'tour-18',
    name: 'Tour 18 Houston',
    location: 'Humble, TX',
    parValues: [4, 4, 5, 3, 4, 4, 5, 3, 4, 4, 4, 3, 5, 4, 4, 3, 4, 5],
    holeHandicaps: [13, 7, 1, 17, 5, 11, 3, 15, 9, 12, 6, 16, 2, 8, 4, 18, 10, 14],
    tees: [
      {
        name: 'Black',
        rating: 74.9,
        slope: 140,
        yardage: 7234
      },
      {
        name: 'Blue',
        rating: 73.4,
        slope: 137,
        yardage: 6934
      },
      {
        name: 'White',
        rating: 71.6,
        slope: 133,
        yardage: 6534
      }
    ]
  },
  {
    id: 'Waterchase',
    name: 'Waterchase Golf Club',
    location: 'Fort Worth, TX',
    parValues: [4, 3, 5, 4, 4, 5, 3, 4, 4, 5, 4, 3, 5, 3, 4, 3, 4, 5],
    holeHandicaps: [11, 15, 7, 13, 1, 3, 17, 5, 9, 4, 10, 16, 6, 14, 12, 18, 2, 8],
    tees: [
      {
        name: 'Black',
        rating: 74.7,
        slope: 135,
        yardage: 7159
      },
      {
        name: 'Gold',
        rating: 73.1,
        slope: 132,
        yardage: 6882
      },
      {
        name: 'Blue',
        rating: 71.1,
        slope: 129,
        yardage: 6408
      }
    ]
  },
  {
    id: 'wilderness',
    name: 'Wilderness Golf Club',
    location: 'Lake Jackson, TX',
    parValues: [4, 5, 4, 3, 4, 4, 5, 3, 4, 5, 4, 4, 3, 4, 5, 3, 4, 4],
    holeHandicaps: [5, 17, 13, 11, 9, 7, 15, 3, 1, 10, 16, 8, 18, 14, 6, 4, 12, 2],
    tees: [
      {
        name: 'Black',
        rating: 73.9,
        slope: 134,
        yardage: 7018
      },
      {
        name: 'Maroon',
        rating: 72.5,
        slope: 130,
        yardage: 6539
      },
      {
        name: 'White',
        rating: 71.4,
        slope: 131,
        yardage: 6446
      }
    ]
  },
  {
    id: 'wildcat-highland',
    name: 'Wildcat Golf Club (Highland)',
    location: 'Houston, TX',
    parValues: [4, 5, 3, 4, 4, 4, 4, 3, 5, 3, 4, 5, 4, 4, 5, 3, 4, 4],
    holeHandicaps: [15, 5, 7, 11, 17, 13, 1, 9, 3, 18, 12, 4, 8, 10, 2, 16, 6, 14],
    tees: [
      {
        name: 'Black',
        rating: 73.6,
        slope: 138,
        yardage: 6954
      },
      {
        name: 'Gold',
        rating: 71.7,
        slope: 134,
        yardage: 6549
      },
      {
        name: 'White',
        rating: 70.2,
        slope: 128,
        yardage: 6254
      }
    ]
  },
  {
    id: 'wildcat-lakes',
    name: 'Wildcat Golf Club (Lakes)',
    location: 'Houston, TX',
    parValues: [4, 4, 5, 3, 4, 4, 4, 3, 5, 4, 5, 4, 3, 4, 4, 5, 3, 4],
    holeHandicaps: [6, 4, 2, 18, 10, 14, 12, 16, 8, 9, 3, 11, 17, 7, 13, 1, 15, 5],
    tees: [
      {
        name: 'Black',
        rating: 74.4,
        slope: 140,
        yardage: 7016
      },
      {
        name: 'Gold',
        rating: 72.4,
        slope: 136,
        yardage: 6534
      },
      {
        name: 'White',
        rating: 70.6,
        slope: 131,
        yardage: 6316
      }
    ]
  },
  {
    id: 'windrose',
    name: 'Windrose Golf Club',
    location: 'Spring, TX',
    parValues: [4, 3, 4, 5, 4, 3, 4, 4, 5, 4, 3, 5, 4, 5, 4, 3, 4, 4],
    holeHandicaps: [17, 15, 7, 3, 11, 5, 9, 1, 13, 6, 18, 12, 4, 10, 8, 14, 16, 2],
    tees: [
      {
        name: 'Black',
        rating: 73.4,
        slope: 130,
        yardage: 6928
      },
      {
        name: 'Blue',
        rating: 72.1,
        slope: 127,
        yardage: 6628
      },
      {
        name: 'White',
        rating: 70.4,
        slope: 124,
        yardage: 6228
      }
    ]
  }
];